import React from 'react';
import { motion } from 'framer-motion';
import { useRecordEditor } from '../../hooks/useRecordEditor';
import RecordEditorForm from './record-editor/RecordEditorForm';

interface DNSRecord {
  id: string;
  name: string;
  type: string;
  value: string;
  ttl: number;
  priority?: number;
  weight?: number;
  port?: number;
  proxied?: boolean;
}

interface RecordEditorProps {
  record: DNSRecord;
  zoneName: string;
  onSave: (recordId: string, updates: Partial<DNSRecord>) => Promise<void>;
  onCancel: () => void;
}

const RecordEditor: React.FC<RecordEditorProps> = ({ record, zoneName, onSave, onCancel }) => {
  const {
    formData,
    isSubmitting,
    errors,
    handleSubmit,
    handleInputChange,
    getPlaceholder,
  } = useRecordEditor(record, onSave, onCancel);

  return (
    <motion.div
      className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 shadow-lg"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-slate-900 dark:text-white">Edit DNS Record</h3>
        <div className="text-sm text-slate-500 dark:text-slate-400">
          {record.name === '@' ? zoneName : `${record.name}.${zoneName}`}
        </div>
      </div>

      <RecordEditorForm
        formData={formData}
        errors={errors}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onInputChange={handleInputChange}
        onCancel={onCancel}
        getPlaceholder={getPlaceholder}
      />
    </motion.div>
  );
};

export default RecordEditor;
